<template>
<div>
    <b-form @submit.prevent="DELRow">
        <b-row>
            <b-col>
                <div class="card-wrapper">
                    <card>
                        <b-row>
                            <b-col sm="4"> TAHUN</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{YearRow.tahun}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4"> KETERANGAN</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{YearRow.keterangan}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4"> TARIKH PERGERAKAN GAJI</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{YearRow.TPG}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4"> AMAUN GAJI</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{YearRow.SalAmtCalc}}
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="4"> AMAUN DALAM BUKU SERVIS </b-col>
                            <b-col sm="1">:</b-col>
                            <b-col sm="6">
                                <b-form-input v-model="YearRow.AmaunTelahTerima" ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="4"> CATATAN </b-col>
                            <b-col sm="1">:</b-col>
                            <b-col sm="6">
                                <b-form-textarea v-model="YearRow.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <div class="pl-lg-4">
                            <b-row>
                                <b-col md="12" class="text-md-right">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <b-button variant="danger" @click="batal()">BATAL</b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </card>
                </div>
            </b-col>
        </b-row>
        <!-- </b-container> -->
    </b-form>
</div>
</template>

<script>
import swal from "sweetalert2";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
export default {
    props: {
        YearRow: {
            type: Object
        },
    },
    methods: {
        DELRow() {
            
            let Search = {
                Calcid:this.YearRow.Calcid,
                AmaunTelahTerima: this.YearRow.AmaunTelahTerima,
                Catatan: this.YearRow.Catatan
            };
            console.log("maklumat", Search)
            GetsalaryService.EditRowTahun(Search)
                .then((resp) => {
                    // console.log(resp.data)
                    swal.fire({
                        title: `KEMASKINI BERJAYA`,
                        text: "",
                        buttonsStyling: true,
                        icon: "success",
                    });

                    this.$emit("refreshPaging");
                    this.batal();
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        batal() {
            this.$emit("batal");
        },
    },
    computed: {
        cloneYearRow() {
            return _.cloneDeep(this.YearRow)
        },
    },
}
</script>
